<template>
    <div class="row">
        <div class="col-xl-12 col-xs-12">
            <h3 class="content-left" v-if="charges.length">Previous charges</h3>
            <h3 class="content-left margin-b" v-if="!charges.length">No invoices yet</h3>
        </div>
        <div class="col-xl-12 col-xs-12" v-if="charges.length">
            <div class="charge-table">
                <table class="content-left large">
                    <tr>
                        <th>date</th>
                        <th>credits purchased</th>
                        <th>amount</th>
                        <th></th>
                    </tr>
                    <tr class="card-content" v-for="charge in charges" v-bind:key="charge.id">
                        <td class="border-l"> {{charge.date}} </td>
                        <td> {{charge.credits_purchased}} </td>
                        <td> ${{charge.amount}} </td>
                        <td class="border-r">
                            <div class="my-btn">
                                <a class="btn-text" :href="charge.hosted_invoice_url" target="_blank">
                                    Invoice
                                </a>
                                <i class="far fa-arrow-alt-circle-down"></i>
                            </div>
                        </td>
                    </tr>
                </table>
                <infinite-loading @infinite="previousCharges">
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                </infinite-loading>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'previousCharge',
  mounted () {
    this.previousCharges()
  },
  data () {
    return {
      charges: [],
      count: 0,
      start: 5
    }
  },
  methods: {
    previousCharges ($state) {
      this.$http.get('/api/billing/previuos_charges/' + this.start).then((res) => {
        this.charges = res.data.data
        this.count = res.data.count
        this.start = this.start + 5
        console.log(res.data)
        $state.loaded()
        if (res.data.data.length === res.data.count) {
          $state.complete()
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss">

.my-btn {
    cursor: pointer;
}

table{
    margin-top: 20px;
    border-collapse: separate;
    border-spacing: 0 5px;
    tr {
        td {
            padding: 10px;
        }
        .border-l {
            border-radius: 5px 0px 0px 5px;
        }
        .border-r {
            border-radius: 0px 5px 5px 0px;
        }
    }
}

.charge-table {
    overflow-y: auto;
    height:250px;
}

.margin-b {
    margin-bottom: 20px;
}

</style>
